export const GET_ADMINLOGIN_REQUEST = "GET_ADMINLOGIN_REQUEST";
export const GET_ADMINLOGIN_SUCCESS = "GET_ADMINLOGIN_SUCCESS";
export const GET_ADMINLOGIN_FAIL = "GET_ADMINLOGIN_FAIL ";



export const GET_REFERAL_CODE_REQUEST = "GET_REFERAL_CODE_REQUEST";
export const GET_REFERAL_CODE_SUCCESS = "GET_REFERAL_CODE_SUCCESS";
export const GET_REFERAL_CODE_FAIL = "GET_REFERAL_CODE_FAIL ";
